import LanguageIcon from '@mui/icons-material/Translate';
import { Stack } from '@mui/material';
import { TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { getDialect } from 'variables';
import { Dialects } from 'types/dialects';
import { getSubjectObjectTextKey, type Pronoun } from 'domain/pronouns';

const PronounsDialectLabel = ({
  dialect,
  pronoun,
}: {
  dialect: Dialects;
  pronoun?: Pronoun;
}) => {
  const { t } = useTranslation();
  const { textKey: dialectKey } = getDialect(dialect) || {
    textKey: 'ui.event-management.learner.profiles.unsupported-language',
  };

  const pronounKey = pronoun ? getSubjectObjectTextKey(pronoun) : '';

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        alignItems: 'flex-start',
      }}
    >
      <LanguageIcon fontSize="small" sx={{ mt: '0.2rem' }} />
      <TextV2 component="p" variant="bodyBold">
        {t(dialectKey)} {pronoun && `- ${t(pronounKey)}`}
      </TextV2>
    </Stack>
  );
};

export default PronounsDialectLabel;
